import {Component, Input, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {MatSort} from "@angular/material/sort";
import {MatTableDataSource} from "@angular/material/table";

export interface FundParticipantsTable {
  id: string;
  name: string;
  role: string;
  url: string;
}

@Component({
    selector: 'deal-fund-participants-table',
    templateUrl: './fund-participants-table.component.html',
    styleUrls: ['./fund-participants-table.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FundParticipantsTableComponent {
  @Input() participants: Array<FundParticipantsTable>;
  @ViewChild('dataSort') public dataSort: MatSort;

  dataColumns: string[] = ['role', 'name'];
  dataSource: MatTableDataSource<FundParticipantsTable>;

  ngOnInit() {
    this.dataSource = new MatTableDataSource(this.participants);
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.dataSort;
  }
}
